import { Injectable } from '@angular/core';
import {HttpService} from 'jrz-http';
import {Observable} from 'rxjs';
import {BASE_URL} from '../base-url.const';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ChildMinderService {
     private readonly URL_PREFIX = '/childminder';

    constructor( private httpService: HttpService ) { }

    public hasChildMinderModule(): Observable<boolean> {
        return this.httpService.get(BASE_URL + this.URL_PREFIX)
            .pipe(
                map((data: any) => {
                    if (data.result) {
                        return data.payload;
                    }
                })
            );
    }
}
